var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('h3',[_vm._v("新闻中心")]),_c('ul',_vm._l((_vm.news),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":"/newsdetails?id="+item.newsId}},[_vm._v(_vm._s(item.newsTitle))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }